import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Heart, Store } from 'lucide-react';

export default function AuthPage() {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(212,175,55,0.14),_transparent_45%),linear-gradient(180deg,#f7f3ee_0%,#faf8f4_48%,#ffffff_100%)] py-14" data-testid="auth-entry-selection-page">
      <div className="container-wedding max-w-4xl">
        <div className="text-center mb-10">
          <p className="caption mb-4" data-testid="auth-entry-selection-kicker">Welcome</p>
          <h1 className="heading-lg mb-3" data-testid="auth-entry-selection-title">Choose your portal</h1>
          <p className="text-base md:text-lg text-stone-600" data-testid="auth-entry-selection-subtitle">
            Select the right space to continue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="auth-entry-selection-options">
          <Link
            to="/client/auth"
            className="group rounded-2xl border border-[#5C0120]/20 bg-white p-7 shadow-sm hover:shadow-md transition-all"
            data-testid="auth-entry-couple-option"
          >
            <div className="w-12 h-12 rounded-full bg-[#5C0120]/10 flex items-center justify-center mb-4">
              <Heart className="h-6 w-6 text-[#5C0120]" />
            </div>
            <h2 className="text-2xl font-semibold text-stone-900 mb-2">Couple</h2>
            <p className="text-stone-600 mb-5">
              Access your planner, guest list, wedding website builder, and wedding day schedule tools.
            </p>
            <Button className="w-full btn-primary" data-testid="auth-entry-couple-button">
              Continue as Couple
            </Button>
          </Link>

          <Link
            to="/vendor/auth"
            className="group rounded-2xl border border-[#D4AF37]/30 bg-white p-7 shadow-sm hover:shadow-md transition-all"
            data-testid="auth-entry-vendor-option"
          >
            <div className="w-12 h-12 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mb-4">
              <Store className="h-6 w-6 text-[#b8911e]" />
            </div>
            <h2 className="text-2xl font-semibold text-stone-900 mb-2">Vendor</h2>
            <p className="text-stone-600 mb-5">
              Sign in to your vendor dashboard or register your business listing for the expo.
            </p>
            <Button className="w-full bg-[#D4AF37] hover:bg-[#D4AF37]/90 text-white" data-testid="auth-entry-vendor-button">
              Continue as Vendor
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
